// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MPNGmtZRYCTl0E {
  text-align: center;
  vertical-align: middle;
}
.uG6xMIaw6M0lze {
  margin-bottom: var(--ds-space-0, 0);
}
.qPcTsvqyROGOwQ {
  border-bottom: 1px dashed var(--ds-text-subtlest, #626f86);
  cursor: pointer;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featureCell": `MPNGmtZRYCTl0E`,
	"cellText": `uG6xMIaw6M0lze`,
	"underlineAuto": `qPcTsvqyROGOwQ`
};
export default ___CSS_LOADER_EXPORT___;
